import { StoreThunk } from './types';
import { toast } from 'react-toastify';

export interface ToastOpts {
  position?: string;
  color?: string;
  ttl?: number;
}

export function showToast(message: string, opts?: ToastOpts): StoreThunk<void> {
  const userOpts = opts || {};
  const settings = {
    autoClose: userOpts.ttl || 8000,
    position: getPosition(userOpts),
    hideProgressBar: true,
    draggable: false,
    className: 'toaster-default-container',
    bodyClassName: 'toaster-default-body'
  };

  return () => {
    toast(message, settings);
  };
}

function getPosition(opts: ToastOpts) {
  const pos = opts.position || 'bottomCenter';

  switch (pos) {
    case 'topRight':
      return toast.POSITION.TOP_RIGHT;

    case 'topLeft':
      return toast.POSITION.TOP_LEFT;

    case 'topCenter':
      return toast.POSITION.TOP_CENTER;

    case 'bottomRight':
      return toast.POSITION.BOTTOM_RIGHT;

    case 'bottomLeft':
      return toast.POSITION.BOTTOM_LEFT;

    default:
      return toast.POSITION.BOTTOM_CENTER;
  }
}



// WEBPACK FOOTER //
// ./src/actions/toast.ts